import { api } from './api';
import { AuthResponse } from './authService';

export interface Tenant {
  id: number;
  name: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTenantPayload {
  name: string;
  status?: string;
}

export interface UpdateTenantPayload {
  name?: string;
  status?: string;
}

export const tenantManagementService = {
  getTenants: async (): Promise<Tenant[]> => {
    const response = await api.get<Tenant[]>('/tenants');
    return response.data;
  },

  createTenant: async (payload: CreateTenantPayload): Promise<Tenant> => {
    const response = await api.post<Tenant>('/tenants', payload);
    return response.data;
  },

  updateTenant: async (
    tenantId: number,
    payload: UpdateTenantPayload,
  ): Promise<Tenant> => {
    const response = await api.patch<Tenant>(`/tenants/${tenantId}`, payload);
    return response.data;
  },

  impersonateTenant: async (tenantId: number): Promise<AuthResponse['data']> => {
    const response = await api.post<AuthResponse['data']>(
      `/tenants/${tenantId}/impersonate`,
    );
    return response.data;
  },
};
